import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CitiesStateInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
}

function getInitialState(): CitiesStateInterface {
    return {
        formVisible: false,
        formVariant: "new",
    }
}

export const CitiesSlice = createSlice({
    name: "CitiesSlice",
    initialState: getInitialState(),
    reducers: {
        changeFormVisibility: (state: CitiesStateInterface, action: PayloadAction<CitiesStateInterface["formVisible"]>) => {
            state.formVisible = action.payload;
        },
        changeFormVariant: (state: CitiesStateInterface, action: PayloadAction<CitiesStateInterface["formVariant"]>) => {
            state.formVariant = action.payload;
        },
        reset: (state: CitiesStateInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.formVisible = initialState.formVisible;
            state.formVariant = initialState.formVariant;
        },
    },
});

export const {
    changeFormVisibility,
    changeFormVariant,
    reset,
} = CitiesSlice.actions;

export const getSelectorForValue = (name: keyof CitiesStateInterface) => (state: RootState) => state.cities[name];

export const CitiesReducer = CitiesSlice.reducer;
